<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.has-text-centered
          .column.is-12
            h3.title.is-3 Firmar Préstamo&nbsp
              a.button.is-dark.is-rounded(@click="backPage")
                i.fas.fa-times
        .columns.has-text-centered
          .column.is-4
            CardPrestamo(:prestamo="prestamo_firmar" :items="items")
          .column.is-8
            .columns.is-12
              ContainerItemsPrestamo(:prestamo="prestamo_firmar" :items="items" @itemsAceptados="checkItemsAceptados" @saveObservacion="saveObservacion" @deleteObservacion='deleteObservacion')
            .column.is-12-mobile.is-4-tablet.is-4(v-show="!verSignature")
              .columns
                .column.is-offset-4.is-4
                  figure.image.is-128x128.has-image-centered
                    img(:src="getImageFirma()")
              .columns
                .column.is-offset-2.is-10
                  a.button.is-black.is-rounded(@click="updateFirma")
                    | Volver a Firmar
            .column.is-12-mobile.is-4-tablet.is-4(v-show="verSignature")
              Signature(@saveFile="checkFile" @sigWebStatus="sigWebStatus")
        .columns.column-blanco
</template>

<script>
  import Loader from '../shared/Loader.vue'
  import NavBarInventario from './layout/NavBarInventario.vue'
  import Signature from './Signature.vue'
  import CardPrestamo from './CardPrestamo.vue'
  import ContainerItemsPrestamo from './ContainerItemsPrestamo.vue'
  import InventarioServices from '../../services/inventario/inventario'
  import { mapState } from 'vuex'

  export default {
    name: 'FirmarSalida',
    components: { Loader, NavBarInventario, InventarioServices, Signature, CardPrestamo, ContainerItemsPrestamo },
    data() {
      return {
        isLoading: true,
        items: [],
        w: 320,
        h: 220,
        ruta: '',
        firma: '',
        nombreFile: '',
        verSignature: false,
        esFirmado: false
      }
    },
    methods: {
      iniciarComponente() {

        if (this.prestamo_firmar.firma === 'E' ) {
          this.nombreFile = `firma_entrega_${this.prestamo_firmar.id}`
        } else {
          this.nombreFile = `firma_recibe_${this.prestamo_firmar.id}`
        }
        this.obtenerItem()
      },

      onLoad (event) {
        console.log(event)
      },

      onDocumentLoad (event) {
        console.log(event)
      },

      checkFile (file) {
        console.log(file)
        this.firma = file
        
        if (this.firma !== 'NoData') {
          const idPrestamo  = this.prestamo_firmar.id || this.prestamo_firmar.id_prestamo
          InventarioServices.firmarPrestamo(idPrestamo, this.prestamo_firmar.firma, this.firma, this.nombreFile)
            .then( data => {
              console.log(data)

              this.displayToast(data.success ? 'toasted-primary': 'bubble', data.respuesta, data.success ? 'check': 'ban', 'Ok')
              if (data.success) {
                this.backInventarios()
              }
            })
            .catch( e => console.log(e))
        } else {
          console.log('No Guardar la Firma')
          let toast = this.$toasted.show('Error: No se ha firmado aún la asignacion.', { 
            theme: "toasted-primary", 
            position: "bottom-right", 
            duration : 3000,
            iconPack: 'fontawesome',
            icon: 'ban',
            action : {
              text : 'Ok',
              onClick : (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
          })
        }
      },

      obtenerItem () {
        InventarioServices.getItemsPrestamo(this.prestamo_firmar.id)
          .then( data => {
            console.log(data)
            this.items = data
          })
          .catch((e) => console.log(e))
          this.isLoading = false
      },

      checkItemsAceptados(items) {
        if (this.prestamo_firmar.estado > 0) {
          if (items.length > 0) {
          this.verSignature = true
          } else {
            this.verSignature = false
          }
        } else {
          this.verSignature = false
        }
        
      },

      backInventarios() {
        this.$store.commit('firmarPrestamo', {})
        this.$router.push('/Inventario/Almacen/Prestamos')
      },

      backPage() {
        this.$store.commit('firmarPrestamo', {})
        this.$router.back()
      },

      saveObservacion (data) {
        this.isLoading = true
        console.log('saveObservacionFA')
        InventarioServices.updateObservacionPrestamo(data.id, this.prestamo_firmar.estado, data.observacion)
          .then((resp) => {
            console.log(resp)
            if (resp.success) {
              let catsub = ''
              if (data.subcategoria === '') {
                catsub = data.categoria
              } else {
                catsub = `${data.categoria} ${data.subcategoria}`
              }
              this.obtenerItem()
              this.displayToast('toasted-priimary',`Observación de ${catsub} ha sido registrada.`, 'done', 'Ok')
            } else {
              this.displayToast('bubble',`Error: ${resp.respuesta}`, 'ban', 'Ok')
            }
            this.isLoading = false
          })
          .catch((error) => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${error.message}`, 'ban', 'OK')
          })
      },

      deleteObservacion(data) {
        this.isLoading = true
        console.log('deleteObservacionFA')
        InventarioServices.updateObservacionIA(data.idArt_Asig, this.prestamo_firmar.estado, '')
          .then((resp) => {
            console.log(resp)
            if (resp.success) {
              let catsub = ''
              if (data.subcategoria === '') {
                catsub = data.categoria
              } else {
                catsub = `${data.categoria} ${data.subcategoria}`
              }
              this.obtenerItem()
              this.displayToast('toasted-primary',`Se ha borrado la observación de ${catsub}`, 'done', 'Ok')
            } else {
              this.displayToast('bubble',`Error: ${resp.respuesta}`, 'ban', 'Ok')
            }
            this.isLoading = false
          })
          .catch((error) => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${error.message}`, 'ban', 'OK')
          })
      },

      displayToast(tema, text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },

      getImageFirma () {
        let path = ''
        const currentUrl = window.location.hostname
        if (this.prestamo_firmar.firma === 'E') {
          path = `https://${currentUrl}${this.prestamo_firmar.firma_entrega}`
        } else {
          path = `https://${currentUrl}${this.prestamo_firmar.firma_recibe}`
        }
        return path
      },

      getMostrarFirma () {
        this.verSignature = this.esFirmado
        return this.verSignature
      },
      updateFirma () {
        this.verSignature = true
      },
      sigWebStatus (val) {
        console.log(val)
        const tema = val ? 'toasted-primary' : 'bubble'
        const text = val ? 'sigWeb instalado' : 'No está instalado sigWeb'
        const icon = val ? 'done' : 'ban'
        this.displayToast(tema, text, icon, 'Ok' )
      }
    },
    created () {
      if (this.prestamo_firmar.firma === 'E') {
        this.esFirmado = this.prestamo_firmar.firma_entrega !== '' ? true : false
      } else {
        this.esFirmado = this.prestamo_firmar.firma_recibe !== '' ? true : false
      }
      this.verSignature = this.esFirmado ? false : true
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['userLogin', 'prestamo_firmar'])
    }
  }
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/FirmarPrestamo.vue